import * as React from 'react';
import { Loader } from 'semantic-ui-react';

import { addModifiers } from '../../shared/helpers';

interface LoaderProps {
  modifiers?: string[];
  active?: boolean;
  inline?: boolean | 'centered';
  size?: 'mini' | 'tiny' | 'small' | 'medium' | 'large' | 'big' | 'huge' | 'massive';
  style?: React.CSSProperties;
}

const LoaderMain = ({ active = true, inline = 'centered', size = 'massive', modifiers = [], style }: LoaderProps) => (
  <div className={addModifiers('loader', modifiers)} style={style}>
    <Loader active={active} inline={inline} size={size} />
  </div>
);

export default LoaderMain;
